import { render, staticRenderFns } from "./AwardedInterInfo.vue?vue&type=template&id=32626815&scoped=true&"
import script from "./AwardedInterInfo.vue?vue&type=script&lang=js&"
export * from "./AwardedInterInfo.vue?vue&type=script&lang=js&"
import style0 from "./AwardedInterInfo.vue?vue&type=style&index=0&id=32626815&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32626815",
  null
  
)

export default component.exports